module.exports = __webpack_public_path__ + "img/Describe.70585538.svg";